import { router } from "@inertiajs/react";
import { Button, Flex, Grid } from "@radix-ui/themes";
import { Eye, Pencil, Trash } from "lucide-react";
import { CarCardCar } from "@/types/shared";
import CarCard from "@/shared/cars/CarCard";
import { useBrand } from "@/shared/brand/useBrand";

/** The owner's cars with view/edit/delete — on /garage and the profile's Garage section. */
export default function GarageGrid({ cars }: { cars: CarCardCar[] }) {
  // A car's public page isn't part of a branded site; editing it is.
  const brand = useBrand();

  const handleDelete = (carId: number) => {
    if (confirm("Are you sure you want to delete this car?")) {
      router.delete(`/driver_cars/${carId}`);
    }
  };

  return (
    <Grid columns={{ initial: "1", sm: "2" }} gap="8">
      {cars.map((car) => (
        <CarCard
          key={car.id}
          car={car}
          actions={
            <Flex gap="3" justify="end">
              {!brand && (
                <Button
                  variant="soft"
                  color="gray"
                  aria-label="View this car's page"
                  onClick={() => router.visit(`/driver_cars/${car.id}`)}
                >
                  <Eye />
                </Button>
              )}
              <Button
                variant="soft"
                color="gray"
                aria-label="Edit this car"
                onClick={() => router.visit(`/driver_cars/${car.id}/edit`)}
              >
                <Pencil />
              </Button>
              <Button
                variant="soft"
                color="crimson"
                aria-label="Delete this car"
                onClick={() => handleDelete(car.id)}
              >
                <Trash />
              </Button>
            </Flex>
          }
        />
      ))}
    </Grid>
  );
}
